import { useQuery } from "@tanstack/react-query";

import { useAppState } from "../context/StateContext";
import ItemJobService from "../services/item.job.service";
import JobFolderService from "../services/job.folder.service copy";
import JobHistoryService from "../services/job.history.service";
import JobService from "../services/job.service";
import { ItemJobSubStatus } from "../util/enums";
import { ItemJobKeys, JobFolderKeys, JobHistoriesKeys, JobKeys } from "../util/queries";

interface Props {
  jobId?: number | string;
}

export const useActionsJob = ({ jobId }: Props) => {
  const { currentUser } = useAppState();
  const getInventoryList = (type?: ItemJobSubStatus[]) => {
    return useQuery({
      queryKey: ItemJobKeys.getInventory([jobId, type]),
      queryFn: async () => {
        const response = await ItemJobService.getInventory({
          type,
          jobId,
          isNewVersion: true,
          companyId: currentUser?.companyId,
        });

        if (response?.data) return response?.data;

        return {};
      },
      enabled: !!jobId,
    });
  };

  const getJobHistories = () => {
    return useQuery({
      queryKey: JobHistoriesKeys.getAll([jobId]),

      queryFn: async () => {
        const response = await JobHistoryService.getAll({
          jobId,
          include: JSON.stringify([{ association: "user" }, { association: "customer" }]),
        });

        if (response?.data) return response?.data;

        return [];
      },
      enabled: !!jobId,
    });
  };

  const getFolders = () => {
    return useQuery({
      queryKey: JobFolderKeys.getByJobId(Number(jobId || 0)),

      queryFn: async () => {
        const response = await JobFolderService.getByJobId(jobId ?? 0);

        if (response?.data) return response?.data;

        return [];
      },
      enabled: !!jobId,
    });
  };

  const getEstimates = () => {
    return useQuery({
      queryKey: JobKeys.getEstimates(Number(jobId || 0)),

      queryFn: async () => {
        const response = await JobService.getEstimates(jobId ?? 0);

        if (response?.data) return response?.data;

        return [];
      },
      enabled: !!jobId,
    });
  };

  return {
    getInventoryList,
    getJobHistories,
    getFolders,
    getEstimates,
  };
};
